var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"rounded":"","outlined":"","small":"","color":"secondary","loading":_vm.loading},on:{"click":function($event){return _vm.correctZone()}}},[_vm._v("Correct Zone")])
}
var staticRenderFns = []

export { render, staticRenderFns }